//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
    data(){
        return{

        }
    },
    computed: {
        ...mapState([
            'ownerView',
        ]),
    },
    methods: {
        article(){
            if(this.ownerView){
                GLOBAL.sign(this.ownerView.id, 'homePage-artitle','homePage')
            }else{
                GLOBAL.sign(0, 'homePage-artitle','homePage')
            }
            // location.href = 'https://m.wecarepet.com/pages/article/cat/0'
            // location.href= '//m.wecarepet.com/blog/newArticleList.html'
            this.$router.push('/mzWxl')
        },
        expert(){
            if(this.ownerView){
                GLOBAL.sign(this.ownerView.id, 'homePage-expertQ&A','homePage')
            }else{
                GLOBAL.sign(0, 'homePage-expertQ&A','homePage')
            }
            // GLOBAL.sign(this.ownerView.id||0, 'LoginPage-expertQ&A')
            // this.$router.push('/expertquestion')
            // location.href = 'https://m.wecarepet.com/pages/expertQuestion/9/33'
            // this.$router.push('/expertquestion')
            this.$router.push('/mzWxl')
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/home/seo.vue